module.exports = __webpack_public_path__ + "static/img/sync-skills1.3f93e0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/sync-skills1.jpg
// module id = nup8
// module chunks = 1